import { render, staticRenderFns } from "./RestaurantOrdersDetail.vue?vue&type=template&id=2e60170c&scoped=true"
import script from "./RestaurantOrdersDetail.vue?vue&type=script&lang=js"
export * from "./RestaurantOrdersDetail.vue?vue&type=script&lang=js"
import style0 from "./RestaurantOrdersDetail.vue?vue&type=style&index=0&id=2e60170c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60170c",
  null
  
)

export default component.exports